const __version__ ='aarp_v1.0.0'

module.exports = {
    __version__
}

